import React, { useEffect, useState } from 'react';
import { Card } from '../../components/Card/Card';
import { H2 } from '../../components/H2/H2';
import { Text } from '../../components/Text/Text';
import { useHistory, Redirect,useLocation } from 'react-router';
import { RebookStatus } from '../../types';
import { OverlaySpinner } from '../../components/OverlaySpinner/OverlaySpinner';
import * as api from '../../services/api';
import { useStore } from '../../store';
import styles from '../Review/Review.module.scss';

// Order statuses that mean the order has already been placed/processed and can no
// longer be booked (mirrors the API's CheckOrderNotBooked middleware). Draft-stage
// statuses (draft, package_details_completed, select_quote_completed,
// shipment_details_completed, additional_info_completed, pay_now) are excluded.
const PROCESSED_ORDER_STATUSES = [
  'booked_for_collection', 'not_collected', 'collected', 'in_transit',
  'out_for_delivery', 'partially_delivered', 'proof_of_delivery', 'under_investigation',
  'rebooked_for_collection', 'futile', 'rejected', 'driver_error', 'no_scans',
  'cancelled', 'refunded', 'partially_refunded', 'fulfilled', 'label:sent',
  'shipment_created', 'delivered', 'missed_delivery', 'on_route_to_pickup',
  'pickup_arrived', 'delivery_arrived', 'missed_pickup', 'damaged', 'processing',
];

// Turn a raw status like "booked_for_collection" into "Booked For Collection".
function formatOrderStatus(status: string): string {
  if (!status) return '';
  return status
    .replace(/[:_]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function CustomLinkOrder() {
  const m = useLocation();
  const history = useHistory();
  console.log(history);

  const code = new URLSearchParams(m.search).get('order');
  const token = new URLSearchParams(m.search).get('token');
  const quoteParam = new URLSearchParams(m.search).get('quote');
  const [status, setStatus] = useState<RebookStatus>('idle');
  const [title, setTitle] = useState<string>('');
  // When an official-quote order has already been placed/processed, we show a
  // dedicated "already placed" screen with the order reference and its status
  // instead of dropping the recipient into the (now un-bookable) funnel.
  const [alreadyPlaced, setAlreadyPlaced] = useState<{ reference: string; status: string } | null>(null);
  const setPickupSuburb = useStore((state) => state.setPickupSuburb);
  const setPickupPostcode = useStore((state) => state.setPickupPostcode);
  const setPickupState = useStore((state) => state.setPickupState);
  const setPickupBuildingType = useStore((state) => state.setPickupBuildingType);
  const setPickupTailLift = useStore((state) => state.setPickupTailLift);
  const setDestinationSuburb = useStore((state) => state.setDestinationSuburb);
  const setDestinationPostcode = useStore((state) => state.setDestinationPostcode);
  const setDestinationState = useStore((state) => state.setDestinationState);
  const setDestinationBuildingType = useStore((state) => state.setDestinationBuildingType);
  const setDropOffTailLift = useStore((state) => state.setDropOffTailLift);
  const setDropOffPOBox = useStore((state) => state.setDropOffPOBox);
  const editItem = useStore((state) => state.editItem);
  const setQuoteId = useStore((s) => s.setQuoteId);
  const setCourierServiceName = useStore((s) => s.setCourierServiceName);
  const setQuotePrice = useStore((s) => s.setQuotePrice);
  const setQuoteInsurance = useStore((s) => s.setQuoteInsurance);
  const setQuoteDelivery = useStore((s) => s.setQuoteDelivery);
  const addInsurance = useStore((state) => state.addInsurance);
  const setQuoteExcludingGstPrice = useStore((s) => s.setQuoteExcludingGstPrice);
  const setOrderId = useStore((state) => state.setOrderId);
  const pushQuotes = useStore((state) => state.pushQuotes);
  const setPickupFirstName = useStore((state) => state.setPickupFirstName);
  const setPickupLastName = useStore((state) => state.setPickupLastName);
  const setPickupCompanyName = useStore((state) => state.setPickupCompanyName);
  const setPickupEmail = useStore((state) => state.setPickupEmail);
  const setPickupAddress1 = useStore((state) => state.setPickupAddress1);
  const setPickupAddress2 = useStore((state) => state.setPickupAddress2);
  const setPickupPhone = useStore((state) => state.setPickupPhone);
  const setDestinationFirstName = useStore((state) => state.setDestinationFirstName);
  const setDestinationLastName = useStore((state) => state.setDestinationLastName);
  const setDestinationCompanyName = useStore((state) => state.setDestinationCompanyName);
  const setDestinationEmail = useStore((state) => state.setDestinationEmail);
  const setDestinationAddress1 = useStore((state) => state.setDestinationAddress1);
  const setDestinationAddress2 = useStore((state) => state.setDestinationAddress2);
  const setDestinationPhone = useStore((state) => state.setDestinationPhone);
  const setPickupTimeWindow = useStore((state) => state.setPickupTimeWindow);
  const setCollectionDate = useStore((state) => state.setCollectionDate);
  const setParcelContent = useStore((state) => state.setParcelContent);
  const setSpecialInstructions = useStore((state) => state.setSpecialInstructions);
  const setValueOfContent = useStore((state) => state.setValueOfContent);
  const setExtendedLiability = useStore((state) => state.setExtendedLiability);
  const setInsuranceValue = useStore((state) => state.setInsuranceValue);
  const setInsuranceFee = useStore((state) => state.setInsuranceFee);
  const setAuthorityToLeave = useStore((state) => state.setAuthorityToLeave);
  const setNoPrinter = useStore((state) => state.setNoPrinter);
  const setSenderType = useStore((state) => state.setSenderType);
  const setCurrentStep = useStore((s) => s.setCurrentStep);
  const setLockOfficialQuote = useStore((s) => s.setLockOfficialQuote);
  const addItem = useStore((state) => state.addItem);

  useEffect(() => {
    (async () => {
      if (code === '' && token === '') {
        return;
      }
      setStatus('in-progress');
      try {
        const response = await api.get<any>(`/custom-link-order/${code}/${token}`);
        if(response.status){
          // Keep the spinner on ('in-progress') through hydration and the
          // official-quote select-quote call so the user sees a loader rather
          // than a blank page until we redirect into the funnel.
          await setReduxStore(response);
        }else{
          setStatus('not-found');
          setTitle(response.message)
        }
      } catch (e) {
        setStatus('idle');
      }
    })();
  }, []);

  const setReduxStore = async (response: any) => {
    
    setStep1ReduxStore(response);
    
    setStep2ReduxStore(response);

    setStep3ReduxStore(response);

    // Official Quote "Book Now": a specific quote card was clicked.
    if (response.data.is_official_quote) {
      // If the order has already been placed/processed, don't attempt to re-book;
      // show a clear "already placed" screen with the reference and current status.
      if (PROCESSED_ORDER_STATUSES.includes(response.data.status)) {
        setAlreadyPlaced({
          reference: response.data.hash_id,
          status: formatOrderStatus(response.data.status),
        });
        setStatus('idle');
        return;
      }

      // Otherwise select the clicked quote, land on shipment-details, and lock nav.
      const locked = await selectOfficialQuote(response, quoteParam);
      if (locked) {
        return;
      }
      // Official quote but we couldn't put the recipient on the locked booking
      // step (expired or the quote couldn't be selected). Show a clear message
      // instead of dropping them at package-details.
      setStatus('not-found');
      setTitle('This quote link is no longer available for booking. Please contact the Fast Courier team.');
      return;
    }

    //redirect on particular step
    if(response.data.status === 'package_details_completed' && response.data.quotes.length > 0){
      setCurrentStep(2);
      history.push('/quotes-comparisons');
    }else if(response.data.status === 'select_quote_completed'){
      setCurrentStep(3);
      history.push('/shipment-details?courierService=' + response.data.selected_quote.courier.name);
    }else if(response.data.status === 'shipment_details_completed'){
      setCurrentStep(4);
      history.push('/additional-info');
    }else{
      setCurrentStep(1);
      history.push('/package-details');
    }
  }

  // Select the clicked quote at its admin-set custom price, hydrate the store from
  // the response, lock the funnel, and route to shipment-details. Returns true when
  // it has taken over routing so the caller skips the status-based redirect.
  const selectOfficialQuote = async (response: any, quoteHash: string | null): Promise<boolean> => {
    const orderHash = response.data.hash_id;
    const quotes = response.data.quotes || [];

    // The /quote resource exposes the quote hash as `id`; the eager-loaded order
    // relation exposes it as `hash_id`. Match on either.
    const matched = quotes.find((q: any) => q.hash_id === quoteHash || q.id === quoteHash);
    const courierName =
      matched?.courier?.name ?? matched?.courierName ?? matched?.service_name ?? '';

    const landOnShipmentDetails = (name: string) => {
      setLockOfficialQuote(true);
      setCurrentStep(3);
      history.push('/shipment-details?courierService=' + name);
    };

    // 1) A specific quote was clicked and it's still selectable: select it now.
    if (quoteHash && matched) {
      try {
        await api.csrf();
        const selectResponse = await api.patch<any>(`/order/${orderHash}/select-quote`, { quoteId: quoteHash });
        const data = selectResponse?.data ?? {};

        setQuoteId(quoteHash);
        setCourierServiceName(courierName);
        setQuotePrice(data.priceExcludingGst);
        setQuoteExcludingGstPrice(data.priceExcludingGst);
        setQuoteDelivery(data.eta);
        setQuoteInsurance(data.insuranceCategory);
        if (data.insurance) {
          addInsurance(data.insurance);
        }

        landOnShipmentDetails(courierName);
        return true;
      } catch (e) {
        // fall through to the already-selected check below
      }
    }

    // 2) The order already has a selected quote (e.g. the customer previously
    // clicked Book Now): land on shipment-details using the stored selection.
    if (response.data.selected_quote) {
      const sel = response.data.selected_quote;
      const selName = sel.courier?.name ?? '';
      setQuoteId(sel.hash_id);
      setCourierServiceName(selName);
      setQuotePrice(sel.price_excluding_gst);
      setQuoteExcludingGstPrice(sel.price_excluding_gst);
      setQuoteDelivery(sel.eta);
      setQuoteInsurance(sel.insurance_category);
      if (response.insurance) {
        addInsurance(response.insurance);
      }
      landOnShipmentDetails(selName);
      return true;
    }

    return false;
  }

  const setStep1ReduxStore = (response: any) => {
    /**
     * Step - 1 Package Details
    */
    setPickupSuburb(response.data.pickup_suburb);
    setPickupPostcode(response.data.pickup_postcode);
    setPickupState(response.data.pickup_state);
    setPickupBuildingType(response.data.pickup_building_type);
    setPickupTailLift(response.data.is_pickup_tail_lift);
    setDestinationSuburb(response.data.destination_suburb);
    setDestinationPostcode(response.data.destination_postcode);
    setDestinationState(response.data.destination_state);
    setDestinationBuildingType(response.data.destination_building_type);
    setDropOffTailLift(response.data.is_dropoff_tail_lift);
    setDropOffPOBox(response.data.is_dropoff_po_box);
    let items = JSON.parse(response.data.items);
  
    items.forEach((item: any, index: any) =>{
      if(index >= 1){
        addItem();
      }
     editItem(index, 'type', item.type);
     editItem(index, 'weight', item.weight);
     editItem(index, 'length', item.length);
     editItem(index, 'width', item.width);
     editItem(index, 'height', item.height);
     editItem(index, 'quantity', item.quantity);
     editItem(index, 'calculatedLength', item.length);
     editItem(index, 'calculatedWidth', item.width);
     editItem(index, 'calculatedHeight', item.height);
    });
  }

  const setStep2ReduxStore = (response: any) => {
    /**
     * Step - 2 Quote Comparison
     */
    setOrderId(response.data.hash_id);

    if(response.data.quotes.length > 0){
      let customLinkOrderQuotes: any = [];
      response.data.quotes.forEach((quote: any, index: any) => {
          let setQuote = {
            'id': quote.hash_id,
            'courierName': quote.courier?.name ?? '',
            'eta': quote.eta,
            'logo': quote.logo_path,
            'name': quote.service_name,
            'rating': quote.rating,
            'pickupCutOffTime': quote.pickup_cutoff,
            'priceExcludingGst': quote.price_excluding_gst,
            'priceIncludingGst': quote.price_including_gst,
            'insuranceCategory': quote.insurance_category,
            'insurance_link': 'http://app.fastcourier.test/documents/QM3248-1118-CourierSure-Goods-in-Transit-Marine-Policy-web.pdf',
          };
          customLinkOrderQuotes.push(setQuote);
          
      });

      pushQuotes(customLinkOrderQuotes, true);
    }

    if(response.data.selected_quote){
      setQuoteId(response.data.selected_quote.hash_id);
      setCourierServiceName(response.data.selected_quote.courier.name);
      setQuotePrice(response.data.selected_quote.price_excluding_gst);
      setQuoteExcludingGstPrice(response.data.selected_quote.price_excluding_gst);
      setQuoteDelivery(response.data.selected_quote.eta);
      setQuoteInsurance(response.data.selected_quote.insurance_category);
      addInsurance(response.insurance);
    }
  }

  const setStep3ReduxStore = (response: any) => {
      if(response.data.pickup_first_name){
        setPickupFirstName(response.data.pickup_first_name);
        setPickupLastName(response.data.pickup_last_name);
        setPickupCompanyName(response.data.pickup_company_name);
        setPickupEmail(response.data.pickup_email);
        setPickupAddress1(response.data.pickup_address_1);
        setPickupAddress2(response.data.pickup_address_2);
        setPickupPhone(response.data.pickup_phone);
        setDestinationFirstName(response.data.destination_first_name);
        setDestinationLastName(response.data.destination_last_name);
        setDestinationCompanyName(response.data.destination_company_name);
        setDestinationEmail(response.data.destination_email);
        setDestinationAddress1(response.data.destination_address_1);
        setDestinationAddress2(response.data.destination_address_2);
        setDestinationPhone(response.data.destination_phone);
        setPickupTimeWindow(response.data.pickup_time_windows);
        setCollectionDate(response.data.collection_date);
        setParcelContent(response.data.parcel_content);
        setSpecialInstructions(response.data.special_instructions);
        setValueOfContent(response.data.value_of_content);
        setAuthorityToLeave(response.data.is_authority_to_leave);
        setNoPrinter(response.data.is_no_printer);
        setSenderType(response.data.sender_type);
    }

    // Extended liability is hydrated unconditionally (outside the pickup-contact
    // guard) because official-quote guest drafts have no pickup contact yet, but
    // the admin's chosen cover must still pre-select on the booking step.
    if (response.data.extended_liability) {
      setExtendedLiability(response.data.extended_liability);
    }
    if (response.data.insurance_value) {
      setInsuranceValue(response.data.insurance_value);
    }
    if (response.data.insurance_fee) {
      setInsuranceFee(response.data.insurance_fee);
    }
  }

  return (
            <div className={styles.root}>
                <OverlaySpinner enabled={status === 'in-progress'} />
                {alreadyPlaced && (
                    <Card color="grey" className={styles.card}>
                        <H2>This order has already been placed</H2>
                        <Text color="grey900" className={styles.note}>
                            Order {alreadyPlaced.reference} has already been booked, so it can no longer be placed again.
                        </Text>
                        <Text color="grey900" className={styles.note}>
                            <strong>Current status:</strong> {alreadyPlaced.status}
                        </Text>
                        <Text color="grey900" className={styles.note}>
                            If you have any questions, please contact the Fast Courier team.
                        </Text>
                    </Card>
                )}
                {!alreadyPlaced && status === 'not-found' && (
                    <Card color="grey" className={styles.card}>
                    <Text color="grey900" className={styles.note}>{title}</Text>
                    </Card>
                )}
            </div>
        );
}
